import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';
import { formatMoneyWithSign } from 'utils/currencyHelper';

export const INITIAL_BID_FORM_VALUES = {
  apr: '0',
  estimatedTaxes: 0,
  estimatedTotalMonthlyPayment: 0,
  fiveYearsPrincipalPaid: 0,
  fiveYearsTotal: 0,

  interestRate: 0,
  offeringId: 1,
  upfrontCharges: 0,
  notes: '',

  title: 0.8,
  titleAmt: 0,
  appraisal: 500,
  upFrontMI: 0,
  otherFees: 200,
  hazardIns: 0.4,
  propTax: 1.3,
  mIrate: 0.5,
  assessments: 0,
  pi: 0,
  mi: 0,
  propertyTaxVal: 0,
  hazardInsuranceVal: 0,
};

export default new Presenter(
  {
    apr: PropTypes.string,
    company: PropTypes.string,
    companyLogo: PropTypes.string,
    companyNmls: PropTypes.number,
    estimatedTaxes: PropTypes.string,
    estimatedTotalMonthlyPayment: PropTypes.string,
    fiveYearsPrincipalPaid: PropTypes.string,
    fiveYearsTotal: PropTypes.string,
    interestRate: PropTypes.string,
    loanAmount: PropTypes.string,
    loanOfficerApplicationUrl: PropTypes.string,
    loanOfficerEmail: PropTypes.string,
    loanOfficerFirstName: PropTypes.string,
    loanOfficerId: PropTypes.number,
    loanOfficerName: PropTypes.string,
    loanOfficerPhoneNumber: PropTypes.string,
    lockPeriod: PropTypes.number,
    nmls: PropTypes.number,
    notes: PropTypes.string,
    offering: PropTypes.string,
    offeringId: PropTypes.number,
    preferredTerm: PropTypes.string,
    profilePicture: PropTypes.string,
    updatedAt: PropTypes.string,
    upfrontCharges: PropTypes.string,
  },
  {
    getTotalCost(bid) {
      const cost = Number.parseInt(this.fiveYearsTotal(bid), 10);
      return formatMoneyWithSign(cost, 'USD');
    },
    getApr(bid) {
      const apr = Number.parseFloat(this.apr(bid)).toFixed(3);
      return `${apr}%`;
    },
    getInterestRate(bid) {
      const interestRate = Number.parseFloat(this.interestRate(bid)).toFixed(3);
      return `${interestRate}%`;
    },
    monthlyPrInMi(bid) {
      const totalMonthlyPayment = Number.parseFloat(this.estimatedTotalMonthlyPayment(bid));
      const taxes = Number.parseFloat(this.estimatedTaxes(bid));
      const monthlyPrInMiPayment = totalMonthlyPayment - taxes;
      return formatMoneyWithSign(monthlyPrInMiPayment, 'USD');
    },
    totalMonthlyPayment(bid) {
      const totalMonthlyPayment = Number.parseFloat(this.estimatedTotalMonthlyPayment(bid)).toFixed(0);
      return formatMoneyWithSign(totalMonthlyPayment, 'USD');
    },
    monthlyEstimatedTaxesInsurance(bid) {
      const monthlyEstimatedTaxesInsurance = Number.parseFloat(this.estimatedTaxes(bid)).toFixed(0);
      return formatMoneyWithSign(monthlyEstimatedTaxesInsurance, 'USD');
    },
    originationCharges(bid) {
      const originationCharges = Number.parseFloat(this.upfrontCharges(bid)).toFixed(0);
      return formatMoneyWithSign(originationCharges, 'USD');
    },
    isOutsideGuidelines(bid) {
      return Number(bid.fiveYearsTotal) === 0 && Number(bid.apr) === 0 && Number(bid.interestRate) === 0;
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/BidPresenter.js